// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","primary":"#56CCF2","wrapper":"_3pyowQSmh9Q0WE64VOGaww","info-container":"_3gRVytGDoKoyAW3MFCMiw6","info":"_3nD1xppWTS_eNlEjQJFj4p","duration":"_3Qo2hNyWGkOUxaLxvezrwK","line":"VHgDmG7pB8O5d-iLE0GJu","line-progress":"_1bQXBgVDzDynMA4l21scAK","play-btn":"_2QaTmsxbOpFWsxXZDMbWjc","pulse-border":"_1DEw3mBB9myE4mtu0245_B","icon":"_1_UN1rYfvN_6gPseaCpVRS","playing":"_3eaKy7n5poKmAPOB7sqzKN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AudioPlayer/AudioPlayer.mod.css
// module id = 1563
// module chunks = 0